export default {
  mounted(el, binding) {
    el.addEventListener('input', e => {
      const vm = binding.instance; // this is the Vue instance.

      vm.errors = { ...vm.errors, [el.name]: e.target.validationMessage };
    });
  },
};
